import React from 'react'
import { Switch } from 'react-router-dom'
import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { AdminCarReservationPrivateRoute, AdminHRAccountingPrivateRoute, AdminPrivateRoute, AdminTrackerPrivateRoute, AdminTrainingPrivateRoute, DriverPrivateRoute, PrivateRoute, PublicRoute } from './routePermission'

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster'),
})
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
})
const LayoutTracker = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutTracker'),
})
const LayoutCar = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutCar'),
})


//Features


// const TrackerController = LoadableRoute({
//     loader: () => import('../components/features/tracker/home/controllers/trackerController'),
// })
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
})
const bypassLoginController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/bypassLoginController'),
})

const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
})
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController'),
})
const LogoutController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/logoutController'),
})

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/home/main/controllers/homeController'),
})

// Info
const InfoController = LoadableRoute({
    // loader: () => import('../components/features/tracker/info/controllers/infoController'),
})


//Settings

const MasterDataController = LoadableRoute({
    loader: () => import('../components/features/settings/landingMenu/controllers/masterDataController'),
})
const TrainingMasterDataController = LoadableRoute({
    loader: () => import('../components/features/settings/landingMenu/controllers/trainingMasterDataController'),
})
const ReportController = LoadableRoute({
    loader: () => import('../components/features/settings/landingMenu/controllers/reportController'),
})
// User Group
const ListUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/userGroup/controllers/listUserGroupsController'),
})

const CreateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/userGroup/controllers/createUserGroupsController'),
})

const UpdateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/userGroup/controllers/updateUserGroupsController'),
})

const ViewUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/userGroup/controllers/viewUserGroupsController'),
})

// Admin User Group
const ListAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/listUserGroupsController'),
})

const CreateAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/createUserGroupsController'),
})

const UpdateAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/updateUserGroupsController'),
})

const ViewAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/viewUserGroupsController'),
})


// Flow
const ListFlowController = LoadableRoute({
    loader: () => import('../components/features/settings/flow/controllers/listFlowsController'),
})

const CreateFlowController = LoadableRoute({
    loader: () => import('../components/features/settings/flow/controllers/createFlowsController'),
})

const UpdateFlowController = LoadableRoute({
    loader: () => import('../components/features/settings/flow/controllers/updateFlowsController'),
})

const ViewFlowController = LoadableRoute({
    loader: () => import('../components/features/settings/flow/controllers/viewFlowsController'),
})

// Course Type
const ListCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/settings/courseType/controllers/listCourseTypeController'),
})

const CreateCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/settings/courseType/controllers/createCourseTypeController'),
})

const UpdateCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/settings/courseType/controllers/updateCourseTypeController'),
})

const ViewCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/settings/courseType/controllers/viewCourseTypeController'),
})


// Course 

const ListCourseWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/listCourseWaitingApproveController'),
})

const DetailCourseWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/detailCourseWaitingApproveController'),
})

const ListCourseWaitingRequestController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/listCourseWaitingRequestController'),
})

const DetailCourseWaitingRequestController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/detailCourseWaitingRequestController'),
})

const ScoreCertCourseController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/scoreCertCourseController'),
})

const ListCourseController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/listCourseController'),
})

const CreateCourseController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/createCourseController'),
})

const UpdateCourseController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/updateCourseController'),
})

const ViewCourseController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/viewCourseController'),
})


// Course History

const ListCourseHistoryWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/listCourseHistoryWaitingApproveController'),
})


const DetailCourseHistoryWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/detailCourseHistoryWaitingApproveController'),
})


const ScoreCertCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/scoreCertCourseHistoryController'),
})

const ListCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/listCourseHistoryController'),
})

const CreateCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/createCourseHistoryController'),
})

const UpdateCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/updateCourseHistoryController'),
})

const ViewCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/settings/course/controllers/viewCourseHistoryController'),
})




// Landing Page for Hr Module
const HrModuleHome = LoadableRoute({
    loader: () => import('../components/features/home/training/controllers/hrModuleHomeController'),
})

const SalaryController = LoadableRoute({
    loader: () => import('../components/features/home/salary/controllers/salaryController'),
})

const SalaryCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/salaryCertification/list/controllers/salaryCertificationController'),
})

const AckSalaryCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/ackSalaryCertification/list/controllers/ackSalaryCertification'),
})

const AdminSalaryCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/adminSalaryCertification/list/controllers/adminSalaryCertification'),
})

const CreateSalaryCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/salaryCertification/create/controllers/createSalaryCertificationController'),
})

const UpdateSalaryCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/salaryCertification/update/controllers/updateSalaryCertificationController'),
})

const ViewSalaryCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/salaryCertification/view/controllers/viewSalaryCertificationController'),
})

const ViewSalaryArkCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/ackSalaryCertification/view/controllers/viewSalaryArkCertificationController'),
})

const ViewSalaryAdminCertficateController = LoadableRoute({
    loader: () => import('../components/features/salary/adminSalaryCertification/view/controllers/viewAdminSalaryCertificationController'),
})


const MyCourseController = LoadableRoute({
    loader: () => import('../components/features/myCourse/controllers/listMyCourseController'),
})

const MyCertController = LoadableRoute({
    loader: () => import('../components/features/myCert/controllers/listMyCertController'),
})

//Report
const ReportCourseController = LoadableRoute({
    loader: () => import('../components/features/report/controllers/reportCourseController'),
})


// HR Module
const TypeReasonHRMasterDataController = LoadableRoute({
    loader: () => import('../components/features/settings/salary/list/controllers/listTypeReasonHRMasterDataController'),
})
const CreateTypeRequestController = LoadableRoute({
    loader: () => import('../components/features/settings/salary/create/controllers/createRequestTypeController'),
})
const UpdateTypeRequestController = LoadableRoute({
    loader: () => import('../components/features/settings/salary/update/controllers/updateRequestTypeController'),
})
const ViewTypeRequestController = LoadableRoute({
    loader: () => import('../components/features/settings/salary/view/controllers/viewRequestTypeController'),
})

const SettingsHRMasterDataController = LoadableRoute({
    loader: () => import('../components/features/settings/salary/settings/controllers/hrSalarySettingsController'),
})



export default () => (
    <Switch>
        {/* Level 7*/}
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history/view/:id/:active' component={ViewCourseHistoryController} layout={LayoutMaster} />

        {/* Level 6 */}
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history/view/:id' component={ViewCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history/update/:id' component={UpdateCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history/scoreCert/:id' component={ScoreCertCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history/waitingapprove/:id' component={DetailCourseHistoryWaitingApproveController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/view/:id/:active' component={ViewCourseController} layout={LayoutMaster} />

        {/* Level 5 */}

        <AdminTrainingPrivateRoute path='/masterdata/training/course/update/:id' component={UpdateCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/view/:id' component={ViewCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/scoreCert/:id' component={ScoreCertCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/waitingrequest/:id' component={DetailCourseWaitingRequestController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/waitingapprove/:id' component={DetailCourseWaitingApproveController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history/waitingapprove' component={ListCourseHistoryWaitingApproveController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history/create' component={CreateCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/coursetype/update/:id' component={UpdateCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/coursetype/view/:id' component={ViewCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/flow/update/:id' component={UpdateFlowController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/flow/view/:id' component={ViewFlowController} layout={LayoutMaster} />

        <PrivateRoute exact path='/masterdata/hr/typeReason/view/:id' component={ViewTypeRequestController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterdata/hr/typeReason/update/:id' component={UpdateTypeRequestController} layout={LayoutMaster} />
        {/* Level 4 */}

        <PrivateRoute exact path='/masterdata/hr/typeReason/create' component={CreateTypeRequestController} layout={LayoutMaster} />

        <AdminHRAccountingPrivateRoute path='/salary/adminCert/view/:id'
            component={ViewSalaryAdminCertficateController} layout={LayoutTracker} />
        <PrivateRoute path='/salary/ackCert/view/:id'
            component={ViewSalaryArkCertficateController} layout={LayoutTracker} />
        <PrivateRoute path='/salary/cert/view/:id'
            component={ViewSalaryCertficateController} layout={LayoutTracker} />
        <PrivateRoute path='/salary/cert/update/:id'
            component={UpdateSalaryCertficateController} layout={LayoutTracker} />


        <AdminTrainingPrivateRoute path='/masterdata/training/course/create' component={CreateCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/waitingrequest' component={ListCourseWaitingRequestController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/waitingapprove' component={ListCourseWaitingApproveController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/coursetype/create' component={CreateCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/flow/create' component={CreateFlowController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/course/history' component={ListCourseHistoryController} layout={LayoutMaster} />

        {/* Level 3 */}
        <PrivateRoute exact path='/masterdata/hr/typeReason' component={TypeReasonHRMasterDataController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterdata/hr/settings' component={SettingsHRMasterDataController} layout={LayoutMaster} />

        <AdminTrainingPrivateRoute path='/masterdata/training/course' component={ListCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/coursetype' component={ListCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/masterdata/training/flow' component={ListFlowController} layout={LayoutMaster} />

        <AdminPrivateRoute path='/masterdata/usergroupsadmin/create' component={CreateAdminUserGroupController} layout={LayoutMaster} />
        <AdminTrackerPrivateRoute path='/masterdata/usergroups/create' component={CreateUserGroupController} layout={LayoutMaster} />


        <PrivateRoute exact path='/salary/cert/create' component={CreateSalaryCertficateController} layout={LayoutTracker} />

        {/* Level 2 */}
        <PrivateRoute path='/report/course' component={ReportCourseController} layout={LayoutMaster} />

        <AdminHRAccountingPrivateRoute exact path='/salary/adminCert' component={AdminSalaryCertficateController} layout={LayoutTracker} />
        <PrivateRoute exact path='/salary/ackCert' component={AckSalaryCertficateController} layout={LayoutTracker} />
        <PrivateRoute exact path='/salary/cert' component={SalaryCertficateController} layout={LayoutTracker} />


        <AdminPrivateRoute path='/masterdata/usergroupsadmin' component={ListAdminUserGroupController} layout={LayoutMaster} />
        <AdminTrackerPrivateRoute path='/masterdata/usergroups' component={ListUserGroupController} layout={LayoutMaster} />

        <PrivateRoute exact path='/crshome/myCourse' component={MyCourseController} layout={LayoutTracker} />
        <PrivateRoute exact path='/crshome/history' component={MyCertController} layout={LayoutTracker} />


        <PrivateRoute exact path='/masterdata/hr' component={TrainingMasterDataController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterdata/training' component={TrainingMasterDataController} layout={LayoutMaster} />



        {/* Level 1 */}
        <PrivateRoute path='/logout' component={LogoutController} layout={LayoutBlank} />
        <PrivateRoute path='/report' component={ReportController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterdata' component={MasterDataController} layout={LayoutMaster} />


        <PrivateRoute exact path='/salary' component={SalaryController} layout={LayoutBlank} />
        <PrivateRoute exact path='/crshome' component={HrModuleHome} layout={LayoutBlank} />
        <PrivateRoute exact path='/' component={HomeController} layout={LayoutBlank} />

        <PublicRoute path='/unauthen' component={UnAuthenController} layout={LayoutBlank} />
        <PublicRoute path='/login' component={Login} layout={LayoutBlank} />
        <PublicRoute path='/bypass/:base64' component={bypassLoginController} layout={LayoutBlank} />

        <PublicRoute component={NotFoundController} layout={LayoutTracker} />

    </Switch>
)


// WEBPACK FOOTER //
// ./src/app/routes/Routes.js